import { KioskThemes } from '../../css/themes/kioskthemes';
import { isNumeric } from '../../helpers/Number';
import { ImageHelper } from '../../controls/ImageHelper/ImageHelper';
import { Icons, IconTypes } from '../../controls/Icon/GenericIcon/GenericIcon.types';
import { GMSizedIcon } from '../../controls/Icon';

export const Assets = () => {
    const renderImages = () => {
        const outerArray = [];
        let index = -1;

        for (const [key, value] of Object.entries(KioskThemes)) {
            const innerArray = [];

            for (const [innerKey, innerValue] of Object.entries(value)) {
                if (innerValue && index !== -1) {
                    innerArray.push(
                        <span
                            key={index}
                            style={{
                                display: 'inline-block',
                                height: '100px',
                                width: '100px',
                            }}
                        >
                            <ImageHelper imageProps={{
                                src: innerValue,
                                alt: key + innerKey,
                            }}
                            />
                        </span>,
                    );
                }
                index++;
            }

            index = -1;
            outerArray.push(innerArray);
        }

        return <div>{outerArray}</div>;
    };

    const renderIcons = () => {
        const icons = [];

        for (const key in Icons) {
            if (!isNumeric(key)) {
                icons.push(
                    <div key={key} style={{ display: 'flex' }}>
                        <GMSizedIcon iconType={key as IconTypes} iconSize={'large'} />
                        {` - ${key}`}
                    </div>,
                );
            }
        }

        return icons;
    };

    return (
        <div style={{ backgroundColor: 'lightGrey' }}>
            <div>{renderImages()}</div>
            <div>{'Available Icons '}{renderIcons()}</div>
        </div>
    );
};
